import { WSAppSource, WSRegMode, WSUserRole } from '../shared';
import { Client } from 'projects/lib-components/src/public_api';

export class WebStoreSettings {
  // webstore from extranet or public
  private webStoreSource: WSAppSource = WSAppSource.NONE;
  get WebStoreSource(): WSAppSource { return this.webStoreSource; }
  // user rh or apprenant
  private webStoreUserRole: WSUserRole = WSUserRole.NONE;
  get WebStoreUserRole(): WSUserRole { return this.webStoreUserRole; }
  // list apprenant for user RH
  private listApprenantsOrderedByClients: Array<Client>; 
  get ListApprenantsOrderedByClients(): Array<Client> { return this.listApprenantsOrderedByClients; }
  // list RHs for user Apprenant
  private listRHsOrderebByClients: Array<Client>;
  get ListRHsOrderebByClients(): Array<Client> { return this.listRHsOrderebByClients; }

  public RegistrationMode: WSRegMode = WSRegMode.NONE;
  constructor(wsSource: WSAppSource, wsUserRole: WSUserRole, apprenantsList: Array<Client>, rhsList: Array<Client>) {
    this.webStoreSource = wsSource;
    this.webStoreUserRole = wsUserRole;
    this.listApprenantsOrderedByClients = apprenantsList;
    this.listRHsOrderebByClients = rhsList
  }
}
